import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {useNavigate, useParams} from "react-router-dom";
import {AuthContext} from "../../../config/AuthContext";
import Login from "../../Login";
import {Aula} from "../../../model/Aula";
import {GetAules} from "../../../dao/GetAules";
import {defaultDubte, Dubte} from "../../../model/Dubte";
import {AlumneInfo, DefaultAulumneInfo} from "../../../model/AlumneInfo";
import {DeleteItem} from "../../../dao/DeleteItem";
import {marcarItem} from "../../../dao/MarcarItem";
import {getDubtes} from "../../../dao/GetDubtes";
import AppSider from "../AppSider";
import {Content} from "antd/es/layout/layout";
import {ColumnsType} from "antd/es/table";
import {Button, Col, FloatButton, Popconfirm, Row, Select, Table, TableProps, Tag} from "antd";
import {BiCheckCircle, BiCross, BiMenu, BiPlus, BiRefresh, BiTrash} from "react-icons/bi";
import HomeColors from "../../../styles/HomeColors";
import {CiClock2} from "react-icons/ci";
import Alert from "antd/es/alert/Alert";
import AvaluacioColors from "../../../styles/AvaluacioColors";
import {ImCross} from "react-icons/im";
import {QuestionCircleOutlined} from "@ant-design/icons";

const Cua = () => {
    const {isLoggedIn, userId, user, setBreadCrumb} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();
    const [dades, setDades] = (useState<any>())
    const [pantalla, setPantalla] = useState(1);

    const [loading, setLoading] = useState(false);
    const [menu, setMenu] = useState(false);

    const [data, setData] = useState<Dubte[]>([]);
    const [showFicha, setShowFicha] = useState(false);
    const [showDubte, setShowDubte] = useState(false);
    const [aulaSel, setSelAula] = useState<string>("");
    const [aulaNom, setAulaNom] = useState<string>("");
    const [isListHidden, setIsListHidden] = useState(true);
    const [aules, setAules] = useState<Aula[] | null>(null);
    const [currUsu, setCurrUsu] = useState<any>();
    const [currentDubte, setCurrentDubte] = useState(defaultDubte);

    const [selectedItem, setSelectedItem] = useState<AlumneInfo>(DefaultAulumneInfo);
    const checkDubtes = async (seleccionado: string) => {
        //alert (aulaSel);
        setData(await getDubtes(seleccionado));
    }

    const checkMarcar = async (id_dubte: number) => {
        setLoading(true);
        if (await marcarItem(id_dubte, aulaSel)) {
            await checkDubtes(aulaSel);
            await checkAules();
        }
        setLoading(false);
    }
    let handleAulaChange = (seleccionado: string) => {
        setLoading(true);
        // Get a reference to the last interval + 1
        const interval_id = window.setInterval(function(){}, Number.MAX_SAFE_INTEGER);

        // Clear any timeout/interval up to that id
        for (let i = 1; i < interval_id; i++) {
            window.clearInterval(i);
        }
        setShowFicha(false);
        setShowDubte(false);
        setSelAula(seleccionado);
        const nomAula = aules?.find(value => {
            if (value.id + "" === seleccionado + "") {
                return value.nom;
            }
        });
        setAulaNom(nomAula?.nom + "");
        if (seleccionado === undefined || seleccionado === '') {
            setIsListHidden(true);
            clearInterval(refreshInterval ? refreshInterval : "");
        } else {
            setIsListHidden(false);
            checkDubtes(seleccionado);
            //checkAules();
            clearInterval(refreshInterval ? refreshInterval : "");
            refreshInterval = setInterval(async () => {
                setLoading(true);
                checkDubtes(seleccionado);
                //checkAules();
                setLoading(false);
            }, 3000);
        }
        setLoading(false);
    };

    const checkAules = async () => {
        const aules = await GetAules(userId);
        setAules(aules);
        console.log(aules);
        if (aules.length === 1)
            handleAulaChange(aules[0].id);
    }


    let refreshInterval: any;
    useEffect(() => {
        checkAules();
        setBreadCrumb([{nom: 'Home', nav: '/home'},
            {nom: 'dubtes', nav: '/cua'}], true);

        return () => {
            window.clearInterval(refreshInterval);

            // Get a reference to the last interval + 1
            const interval_id = window.setInterval(function(){}, Number.MAX_SAFE_INTEGER);

            // Clear any timeout/interval up to that id
            for (let i = 1; i < interval_id; i++) {
                window.clearInterval(i);
            }
        };
    }, []);

    async function esborrar(id: number) {
        if (await DeleteItem(id, aulaSel)) {
            await checkDubtes(aulaSel);
            await checkAules();
            setShowFicha(false);
            setShowDubte(false);
        }
    }

    function setPnt(value: number) {
        setPantalla(value);
    }


    const columns: ColumnsType<any> = [
        {
            key: 'nom',
            dataIndex: 'nom',
            width: 100,
            render: (e, ele) => (
                <>
                    <Tag
                        color={HomeColors.colors.color2}>{ele.nom + " \n" + ele.cognoms}</Tag>
                    <br/>

                    <>
                        {ele.atencio === null &&
                            <>
                                <Tag color={HomeColors.colors.color3}>EN CUA</Tag>
                            </>
                        }
                        {ele.atencio !== null &&
                            <>
                                <Tag color={HomeColors.colors.color4}>ATENENT</Tag>
                            </>
                        }
                    </>
                </>
            ),
        },
        {
            key: 'actions',
            dataIndex: 'actions',
            width: 200,
            render: (e, ele) => (
                <>
                    {ele.atencio === null && (<Button title={"Atendre"} onClick={() => checkMarcar(ele.id)} size={"large"}
                                                      style={{backgroundColor: HomeColors.colors.color6}}><CiClock2/>
                    </Button>)}
                    {ele.atencio !== null && <Button title={"Resolt"} onClick={() => checkMarcar(ele.id)} size={"large"}
                                                     style={{backgroundColor: HomeColors.colors.color4}}><BiCheckCircle/>
                    </Button>}
                </>
            ),
        },
        {
            key: 'borrar',
            dataIndex: 'borrar',
            width: 200,
            render: (e, ele) => (
                <>

                    <Popconfirm
                        title="Treure de cua"
                        description="Vols treure de cua aquest alumne/a?"
                        onConfirm={() => esborrar(ele.id)}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                    >
                        <Button size={"large"} title={"Treure de cua"} style={{backgroundColor: HomeColors.colors.color5}}><BiTrash/></Button>
                    </Popconfirm>
                </>
            ),
        },
    ];


    const tableProps: TableProps<any> = {
        loading
    };


    if (isLoggedIn) {
        return (
            <>
                {menu && <AppSider currentVal={1} setPantalla={setPnt}/>}
                <Content style={{padding: '0 24px', minHeight: 280}}>
                    <Row style={{marginBottom: 20}}>
                        <Col span={24}>
                            <Select disabled={!aules || aules.length <= 1}
                                    style={{width: '100%'}}
                                    value={aulaSel}
                                    onChange={handleAulaChange}
                                    placeholder="Seleccionar aula"
                            >
                                {aules?.map((alumne: any) => (
                                    <Select.Option key={alumne.id} value={alumne.id}>
                                        {alumne.nom} {alumne.cognoms}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Col>
                    </Row>
                    {aulaNom === '' && <Alert message={"Sel·lecciona una aula..."}/>}
                    {aules && aules?.length > 0 ? <Table
                        showHeader={false}
                        size={"large"}
                        title={() => `LLISTAT DE DUBTES ${aulaNom.toUpperCase()}`}
                        {...tableProps}
                        bordered={true}
                        columns={columns}
                        dataSource={data}
                    /> : <p>{"No tens aules asignades..."}</p>
                    }
                    <FloatButton
                        shape="circle"
                        type="primary"
                        onClick={() => setMenu(!menu)}
                        style={{ insetInlineStart: 97, backgroundColor: AvaluacioColors.colors.color6 }}
                        icon={!menu ? <BiMenu /> : <ImCross />} />
                </Content>

            </>
        );
    } else {
        return (
            <Login/>
        );
    }
};

export default Cua;
